<template>
    <div class="lp-shell">
        <div class="lp-inner">

            <a href="/" class="lp-logo">
                <img :src="$platformBrand.logoUrl" :alt="$platformBrand.name" style="height:36px; width:auto;">
            </a>

            <transition name="lp-fade" mode="out-in">

                <!-- Phone entry -->
                <div v-if="!codeSent" key="phone">
                    <h1 class="lp-heading">Log in with your phone</h1>
                    <p class="lp-subtext">We'll send you a one-time code to verify it's you.</p>

                    <div v-if="error" class="lp-alert">{{ error }}</div>

                    <div class="form-group">
                        <label class="lp-label">Phone number</label>
                        <vue-tel-input
                            v-model="phoneRaw"
                            v-on:validate="onPhoneValidate"
                            class="lp-tel"
                        ></vue-tel-input>
                        <small v-if="phoneError" class="text-danger">{{ phoneError }}</small>
                    </div>

                    <button
                        type="button"
                        class="btn btn-dark btn-block lp-cta mt-4"
                        :disabled="isLoading"
                        @click="sendCode"
                    >
                        <span v-if="isLoading">
                            <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
                            Sending code...
                        </span>
                        <span v-else>Send code <i class="bi bi-arrow-right"></i></span>
                    </button>

                    <p class="text-center mt-3 lp-footer">
                        <a href="/login" class="text-dark">Back to email login</a>
                        &nbsp;·&nbsp;
                        <a href="/register-business" class="text-dark">Create account</a>
                    </p>
                </div>

                <!-- Code sent confirmation -->
                <div v-else key="sent" class="text-center">
                    <div class="lp-sent-icon mb-3">
                        <i class="bi bi-phone"></i>
                    </div>
                    <h1 class="lp-heading">Check your phone</h1>
                    <p class="lp-subtext">
                        A 6-digit code is on its way to
                        <strong>...{{ maskedPhone }}</strong>.
                        Enter it on the next screen.
                    </p>
                    <a
                        :href="'/otp-verification?otp-no=' + phoneFormatted"
                        class="btn btn-dark btn-block lp-cta"
                    >
                        Enter code <i class="bi bi-arrow-right"></i>
                    </a>
                    <button
                        type="button"
                        class="btn btn-link text-secondary btn-block mt-1 lp-skip"
                        @click="codeSent = false"
                    >
                        Use a different number
                    </button>
                </div>

            </transition>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'LoginWithPhone',

        data() {
            return {
                phoneRaw:       '',
                phoneFormatted: '',
                phoneValid:     false,
                phoneError:     '',
                isLoading:      false,
                error:          '',
                codeSent:       false,
                maskedPhone:    '',
            };
        },

        methods: {
            onPhoneValidate(phone) {
                this.phoneValid = phone.valid;
                if (phone.valid) {
                    this.phoneFormatted = phone.number;
                    this.phoneError = '';
                }
            },

            async sendCode() {
                this.error     = '';
                this.phoneError = '';

                if (!this.phoneValid) {
                    this.phoneError = 'Enter a valid phone number.';
                    return;
                }

                this.isLoading = true;
                try {
                    await axios.post('/api/request-login-otp', { phone: this.phoneFormatted });
                    this.maskedPhone = this.phoneFormatted.slice(-4);
                    this.codeSent    = true;
                } catch (err) {
                    this.error = err.response?.data?.message
                        || 'Something went wrong. Please try again.';
                } finally {
                    this.isLoading = false;
                }
            },
        },
    };
</script>

<style scoped>
.lp-shell {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    padding: 2rem 1.25rem;
}

.lp-inner {
    width: 100%;
    max-width: 400px;
}

.lp-logo {
    display: block;
    text-align: center;
    margin-bottom: 2.5rem;
}

.lp-heading {
    font-size: 1.6rem;
    font-weight: 700;
    color: #212529;
    line-height: 1.25;
    margin-bottom: 0.5rem;
}

.lp-subtext {
    color: #6c757d;
    font-size: 0.9rem;
    margin-bottom: 2rem;
}

.lp-label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #6c757d;
    margin-bottom: 0.4rem;
    display: block;
}

.lp-tel {
    border: none !important;
    border-bottom: 2px solid #dee2e6 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
}

.lp-tel:focus-within {
    border-bottom-color: #fd4719 !important;
}

.lp-cta {
    padding: 0.8rem 1rem;
    font-size: 1rem;
    font-weight: 600;
}

.lp-skip {
    font-size: 0.875rem;
    text-decoration: none;
}

.lp-footer {
    font-size: 0.875rem;
    color: #6c757d;
}

.lp-alert {
    background: #fff5f5;
    border: 1px solid #f5c6cb;
    border-radius: 6px;
    color: #842029;
    font-size: 0.875rem;
    padding: 0.65rem 1rem;
    margin-bottom: 1.25rem;
}

.lp-sent-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: #f8f9fa;
    color: #212529;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75rem;
    margin: 0 auto;
}

.lp-fade-enter-active,
.lp-fade-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.lp-fade-enter { opacity: 0; transform: translateY(10px); }
.lp-fade-leave-to { opacity: 0; transform: translateY(-8px); }
</style>
